// Copyright Epic Games, Inc. All Rights Reserved.

import {
  EInstallationStatus,
  IInstallationGroupProgressMessage,
} from "../../services/EOSHelperAPI";
import {
  SET_INSTALLATION_CANCELLING,
  SET_INSTALLATION_ERROR_CODE,
  SET_INSTALLATION_PROGRESS,
  SET_INSTALLATION_TASK_INFO,
} from "./actions";
import { Actions } from "../actions";

export const installationFeatureStoreKey = "installation";
export interface IInstallationState {
  progress: IInstallationGroupProgressMessage;
  groupId: string;
  cancellingInstallation: boolean;
  pulledMetadata: boolean;
  errorCode: string;
}

export const initialInstallationState: IInstallationState = {
  progress: {
    currentTaskProgress: {
      taskId: "",
      completed: false,
      averageDiskReadSpeed: 0n,
      averageDiskWriteSpeed: 0n,
      downloadedBytes: 0n,
      averageDownloadSpeed: 0n,
      completionProgress: 0,
      diskReadBytes: 0n,
      diskWriteBytes: 0n,
      status: EInstallationStatus.Installing,
      totalDownloadRequiredBytes: 0n,
      alertDescription: "",
      alertCode: "",
      title: "",
    },
    currentTaskId: "",
    currentTaskNumber: 0,
    numInstallations: 0,
    numInstalled: 0,
  },
  groupId: "",
  cancellingInstallation: false,
  pulledMetadata: false,
  errorCode: "",
};

export function installationReducer(
  state: IInstallationState = initialInstallationState,
  action: Actions
): IInstallationState {
  switch (action.type) {
    case SET_INSTALLATION_PROGRESS: {
      return { ...state, ...action.payload };
    }
    case SET_INSTALLATION_TASK_INFO: {
      return { ...state, ...action.payload };
    }
    case SET_INSTALLATION_CANCELLING: {
      return { ...state, ...action.payload };
    }
    case SET_INSTALLATION_ERROR_CODE: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}
